import { render, staticRenderFns } from "./VolNewsDetail.vue?vue&type=template&id=2d5a29b2&scoped=true"
import script from "./VolNewsDetail.vue?vue&type=script&lang=js"
export * from "./VolNewsDetail.vue?vue&type=script&lang=js"
import style0 from "./VolNewsDetail.vue?vue&type=style&index=0&id=2d5a29b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a29b2",
  null
  
)

export default component.exports